<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" aria-current="page">
        <a class=" text-decoration-none">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
          </svg>
          <span jhiTranslate="global.menu.home">news</span>
        </a>
      </li>
    </ol>
  </nav>

  <div class="mt-4 p-5 bg-primary text-white rounded">
    <h1>SUCHEN ZUR TEAM VERSTÄRKUNG ENGAGIERTE SEXUALBEGLEITER/INNEN</h1>
    <a class="nav-link text" routerLink="/info/infos-fur-anbieterinnen">
      mehr infos
    </a>
  </div>

  <div class="pt-2 row mb-2">

    <!--  -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog18_2.png" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Sexualität im Alter – Podium Adullam Basel am 11.06.2024</h4>
              <div class="mb-1 text-body-secondary">24.5.2024</div>
              <p class="card-text mb-auto">Isabelle Kölbl: <q>Es wäre eigentlich alles sehr einfach... wenn natürlicher mit der Sexualität umgegangen wird, wenn sie ihre Berechtigung und ihren Raum erhält</q> </p>
              <a class="nav-link text-primary" routerLink="/blog/18">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog15_1.png" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Zeitschrift Golden Generation – Interview von Sacha Jacqueroud mit Isabelle
                Kölbl</h4>
              <div class="mb-1 text-body-secondary">8.1.2024</div>
              <p class="card-text mb-auto"><q>Sex ist das beste Antidepressivum!</q></p>
              <a class="nav-link text-primary" routerLink="/blog/15">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!--  -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog17_1.png" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Watson: Film Interview mit Sexualbegleiter Markus von sexcare</h4>
              <div class="mb-1 text-body-secondary">5.12.2023</div>
              <p class="card-text mb-auto">
                Gegen 50 Männer interessieren sich jährlich für die Ausbildung zum sexcare Sexualbegleiter.  Wieso gibt es nicht mehr männliche Anbieter</p>
              <a class="nav-link text-primary" routerLink="/blog/17">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog16_1.png" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Vorarlberger Nachrichten: Sexualassistenz wird legalisiert</h4>
              <div class="mb-1 text-body-secondary">6.11.2023</div>
              <p class="card-text m-auto">Unsere Beteiligung in der Arbeitsgruppe VISS (Vorarlberger Initiative
                Selbstbestimmte Sexualität)
                in Götzis trägt endlich Früchte!</p>
              <a class="nav-link text-primary" routerLink="/blog/16">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 17.1.2022 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog14_1.png" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Isabelle Kölbl am Kulturzyklus Kontrast FH OST</h4>
              <div class="mb-1 text-body-secondary">17.1.2022</div>
              <p class="mb-auto"><q>Ein gelebtes Sexualleben kann Entspannung auf eine ganze Institutionsabteilung
                bringen</q></p>
              <a class="nav-link text-primary" routerLink="/blog/14">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 28.5.2020 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog13_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Das lange Warten hat ein Ende</h4>
              <div class="mb-1 text-body-secondary">28.5.2020</div>
              <p class="mb-auto">Wir freuen uns ab 6. Juni wieder persönliche Treffen anbieten zu dürfen.</p>
              <a class="nav-link text-primary" routerLink="/blog/13">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 1.11.2019 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog12_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Einblicke in meine Arbeit als Sexualbegleiterin – Workshop Achtung Liebe –
                Oberegg</h4>
              <div class="mb-1 text-body-secondary">1.11.2019</div>
              <p class="mb-auto"><q>Achtung Liebe» ist eine schweizweite Non-Profit-Organisation von Student/innen</q></p>
              <a class="nav-link text-primary" routerLink="/blog/12">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 1.11.2019 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog11_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Gender Diversität – Alles ausser gewöhnlich – im Land von Sexualität
                und Handicap</h4>
              <div class="mb-1 text-body-secondary">1.11.2019</div>
              <p class="mb-auto">Eine der erst gestellten Fragen von Beauftragten/Institutionen In Supportgesprächen</p>
              <a class="nav-link text-primary" routerLink="/blog/11">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 2.07.2019 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog10_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Aarauer Nachrichten – Keine Prostitution, sondern eine Partnerschaft auf
                Zeit</h4>
              <div class="mb-1 text-body-secondary">2.07.2019</div>
              <p class="mb-auto">Das Zustandekommen dieses Artikels in den Aarauer Nachrichten hat mich</p>
              <a class="nav-link text-primary" routerLink="/blog/10">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 15.4.2019  -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog9_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Luzerner Zeitung <q>Eine Sexarbeiterin mit besonderem Ziel</q></h4>
              <div class="mb-1 text-body-secondary">15.4.2019</div>
              <p class="mb-auto">Sexcare unterscheidet sich wesentlich von anderen Angeboten und ist in</p>
              <a class="nav-link text-primary" routerLink="/blog/9">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 15.4.2019  -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog8_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Berner Zeitung <q>Ich muss für die Männer meine Hand ins Feuer legen</q></h4>
              <div class="mb-1 text-body-secondary">15.4.2019</div>
              <p class="mb-auto">sexcare setzt sich für Gleichberechtigung ein: Auf was Frau mit</p>
              <a class="nav-link text-primary" routerLink="/blog/8">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 26.2.2019 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog7_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Living Library – sexcare ist eingeladen als lebendes Buch…</h4>
              <div class="mb-1 text-body-secondary">26.2.2019</div>
              <p class="mb-auto"><q>Leihe</q> Gründerin und Geschäftsführerin Isabelle Kölbl in Begleitung einer Ihrer</p>
              <a class="nav-link text-primary" routerLink="/blog/7">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 28.10.2018 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog6_1.png" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Podiumsgast beim Berlinale Film Gewinner <q>Touch me not</q></h4>
              <div class="mb-1 text-body-secondary">28.10.2018</div>
              <p class="mb-auto">Der Film Touch me not gewann 2018 den Goldenen Bären</p>
              <a class="nav-link text-primary" routerLink="/blog/6">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3.10.2018 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog5_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Sexcare als Gastreferentin Clubanlass Kiwanis-Luzern-Pilatus 1. Oktober 2018
                Hotel Wilden Mann</h4>
              <div class="mb-1 text-body-secondary">3.10.2018</div>
              <p class="mb-auto">Ich bedanke mich recht herzlich beim Club Präsidenten Daniel Meyer</p>
              <a class="nav-link text-primary" routerLink="/blog/5">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 18.7.2018  -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog4_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Sexualbegleitung sexcare in den USA angekommen</h4>
              <div class="mb-1 text-body-secondary">18.7.2018</div>
              <p class="mb-auto">Dass sexcare.ch sich als erste, fachgeführte Erotikplattform für Sexualbegleitung in</p>
              <a class="nav-link text-primary" routerLink="/blog/4">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 6.4.2018 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog3_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Erste sexcare Schulung für männliche Sexualbegeiter</h4>
              <div class="mb-1 text-body-secondary">6.4.2018</div>
              <p class="mb-auto">Wir freuen uns, anfangs Mai die erste Schulung für Sexualbegleiter</p>
              <a class="nav-link text-primary" routerLink="/blog/3">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 11.2.2017 -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog2_1.jpg" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">Lehrauftrag an der FHS St. Gallen</h4>
              <div class="mb-1 text-body-secondary">11.2.2017</div>
              <p class="mb-auto">Seit Januar 2017 unterstützen wir an der Fachhochschule St. Gallen</p>
              <a class="nav-link text-primary" routerLink="/blog/2">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 5.10.2016  -->
    <div class="col-xl-6 d-flex align-items-stretch mb-4">
      <div class="card shadow-sm">
        <div class="row g-0">
          <div class="col-sm-4">
            <img src="/../../../content/blog/blog1_1.png" class="h-100 card-img" alt=""
                 style="object-fit: cover;">
          </div>
          <div class="col-sm-8">
            <div class="card-body d-flex flex-column">
              <h4 class="mb-0 text-primary">sexcare als Podiumsgast Kulturzyklus Kontrast 2016 FHS St. Gallen, 26. Oktober
                2016</h4>
              <div class="mb-1 text-body-secondary">5.10.2016</div>
              <p class="mb-auto"><q>The Sessions</q> Ein Film zeigt emotional, wie der bis zum</p>
              <a class="nav-link text-primary" routerLink="blog/1/">
                weiter lesen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
